export enum ImportMethod {
  Append = 'append',
  Replace = 'replace',
}
